<template>
  <header class="app-header">
    <div class="inner">
      <router-link to="/wallet" class="brand">
        <span class="logo" :style="{ backgroundImage: `url(${logoUrl})` }" role="img" aria-label="Nexus Gold"></span>
        <span class="brand-text">
          <span class="name text-gold-gradient">NEXUS GOLD</span>
          <span class="sub">{{ $t('gold_standard') }} WEB3 · {{ $route.meta.title }}</span>
        </span>
      </router-link>

      <div class="actions">
        <button class="lang" type="button" @click="toggleLang">
          <span class="material-symbols-outlined">translate</span>
          {{ $i18n.locale == 'zh' ? 'EN' : '中文' }}
        </button>
        <button class="home" type="button" :title="$t('back_member')" :aria-label="$t('back_member')" @click="$root.backToMember()">
          <span class="material-symbols-outlined">home</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return { logoUrl: `${process.env.BASE_URL}logo-text.jpg` };
  },
  methods: {
    toggleLang() {
      this.$root.changeLan(this.$i18n.locale == 'zh' ? 'en' : 'zh');
    },
  },
};
</script>

<style lang="scss" scoped>
.app-header {
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(11, 14, 20, 0.85);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid var(--hairline);
  padding-top: env(safe-area-inset-top);
}

.inner {
  max-width: var(--page-max);
  margin: 0 auto;
  height: 60px;
  padding: 0 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

// logo-text.jpg is the full square brand art; zoom into the NG mark
.logo {
  flex: none;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background-color: #2b2d2b;
  background-repeat: no-repeat;
  background-size: 250%;
  background-position: 54% 28%;
}

.brand-text {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.name {
  font-family: var(--font-display);
  font-weight: 700;
  font-size: 20px;
  line-height: 22px;
  letter-spacing: -0.01em;
}

.sub {
  font-size: 10px;
  letter-spacing: 0.08em;
  color: var(--outline);
  white-space: nowrap;
}

.actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.lang {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 32px;
  padding: 0 10px;
  border-radius: 999px;
  background: var(--surface-container);
  border: 1px solid var(--hairline);
  font-size: 12px;
  font-weight: 600;
  color: var(--on-surface-variant);
  .material-symbols-outlined { font-size: 16px; color: var(--gold-text); }
}

.home {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(212, 175, 55, 0.5);
  background: var(--surface-container);
  color: var(--gold-text);
}
</style>
